import { useMemo } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import type { RadarTimestep } from '../types/radar.types';
import { getUserTimezoneOffset } from '@/utils/dateTimeUtils';

dayjs.extend(utc);

export function useRadarTimesteps(
  isFuture: boolean,
  count: number,
): RadarTimestep[] {
  return useMemo(() => {
    return computeTimesteps(isFuture, count);
  }, [isFuture, count]);
}

export function computeTimesteps(isFuture: boolean, count: number): RadarTimestep[] {
  const userOffsetHours = getUserTimezoneOffset() ?? 0;

  // Determine the current hour anchor in the user's local timezone, then convert to UTC for the API
  const localNow = dayjs().utc().add(userOffsetHours, 'hour');
  const currentHourUtc = localNow.startOf('hour').subtract(userOffsetHours, 'hour');

  const steps: RadarTimestep[] = [];

  if (isFuture) {
    for (let i = 0; i < count; i++) {
      const ts = currentHourUtc.add(i, 'hour');
      steps.push({
        index: i,
        timestamp: ts.unix(),
        isoString: `${ts.format('YYYY-MM-DDTHH:mm:ss')}Z`,
      });
    }
  } else {
    for (let i = 0; i < count; i++) {
      const hoursBack = count - 1 - i;
      const ts = currentHourUtc.subtract(hoursBack, 'hour');
      steps.push({
        index: i,
        timestamp: ts.unix(),
        isoString: `${ts.format('YYYY-MM-DDTHH:mm:ss')}Z`,
      });
    }
  }

  return steps;
}
